module.exports = __webpack_public_path__ + "static/media/join_our_community_video.21b05864.png";